import { render, staticRenderFns } from "./DangerDetailsDrawer.vue?vue&type=template&id=accb4904&scoped=true&"
import script from "./DangerDetailsDrawer.vue?vue&type=script&lang=js&"
export * from "./DangerDetailsDrawer.vue?vue&type=script&lang=js&"
import style0 from "./DangerDetailsDrawer.vue?vue&type=style&index=0&id=accb4904&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "accb4904",
  null
  
)

export default component.exports